// DS: TODO
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorIndent = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M3 5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM11 9.6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1ZM11 14.3a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1ZM4 18a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4ZM6.656 12.3a.4.4 0 0 0 0-.601L3.664 9.08A.4.4 0 0 0 3 9.381v5.237a.4.4 0 0 0 .664.301l2.992-2.618Z"
    })));
};
EditorIndent.displayName = 'EditorIndent';
export default EditorIndent;

//# sourceMappingURL=EditorIndent.js.map